import AppRecord from './AppRecord.js'

class AifCommitment extends AppRecord {
}

export default AifCommitment
